import { isEmptyObject, isString } from '@yembo/yemblocks-core/dist/_util';

interface AppendUrlParamsProps {
  method: string;
  url: string;
  data: Record<string, unknown>;
}

export const appendUrlParams = ({ method, url, data }: AppendUrlParamsProps): string => {
  const shouldAppendUrlParams = method.toLowerCase() === 'get' && !isEmptyObject(data);

  if (shouldAppendUrlParams) {
    const urlParams = Object.entries(data)
      .map(([key, value]) => `${key}=${isString(value) ? value : JSON.stringify(value)}`)
      .join('&');

    return url.includes('?') ? `${url}&${urlParams}` : `${url}?${urlParams}`;
  }

  return url;
};
